export default function admin({ to, next, store }) {
  //check the role of the user in the getter
  // if not an admin, then display not found page!
  if (store.getters["user/isAdmin"]) next();
  else next({ path: '/not-found' });
}
